enum ResourceType {
  SELECT_RESOURCE = '[RESOURCE] SELECT',
}

export default ResourceType;
